import React from 'react';
import { observer } from 'mobx-react';
import { Selected } from 'libs/forms/styles';

export const ColorSelection = observer(({ selected, fieldStore }) => (
  <Selected color={selected[fieldStore.conf.appKey]}>
    {selected[fieldStore.conf.labelKey]}
  </Selected>
));
